import Vue from 'vue'
import Router from 'vue-router'

import Sections from '../components/views/sections'
import SectionSearch from '../components/views/section/SectionSearch'
import Section from '../components/views/section/section'
import NewSection from '../components/views/section/newsection'
import AssetDetail from '../components/views/assetDetail/AssetDetail'
import AddUpdateAssets from '../components/views/AddUpdateAssets'
import AttributeManagement from '../components/views/AttributeManagement'
import SignInCallback from '../components/Auth/SignInCallback.vue'
import SilentRenewCallback from '../components/Auth/SilentRenewCallback.vue'
import NoAccess from '../components/Auth/NoAccess.vue'
import SectionSettings from '../components/views/section/Settings.vue'
import catalogue from '../components/views/catalogue/catalogue.vue'
import AssetList from '../components/views/section/assetlist.vue'
import AXPSettings from '../components/views/AXPSettings.vue'
import PDF2Pog from '../components/views/PDF2Pog.vue'
import PDF2PogTabular from '../components/views/PDF2PogTabular.vue'
import Profiles from '../components/views/profiles/Profiles.vue'
import DataCleansing from '../components/views/DataCleansing.vue'
import ProductSearchAdmin from '../components/views/ProductSearchAdmin.vue'
import store from '../vuex/store'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Sections',
      component: Sections
    },
    {
      path: '/profiles',
      name: 'Profiles',
      component: Profiles
    },
    {
      path: '/mainsettings',
      name: 'Main Settings',
      component: AXPSettings
    },
    {
      path: '/pdf2excel',
      alias: '/pdf2pog',
      name: 'PDF > AutoPOG',
      component: PDF2Pog
    },
    {
      path: '/pdf2excel/tabular',
      alias: '/pdf2pog/tabular',
      name: 'AutoPOG',
      component: PDF2PogTabular
    },
    {
      path: '/pdf2excel/visual',
      alias: '/pdf2pog/visual',
      redirect: '/pdf2excel/tabular'
    },
    {
      path: '/section/create/wizard',
      name: 'New Section',
      component: NewSection
    },
    {
      path: '/section/:sectionName',
      name: 'Section',
      component: Section,
      props: true
    },
    {
      path: '/sectionsettings/:sectionName',
      name: 'Section Settings',
      component: SectionSettings,
      props: true
    },
    {
      path: '/section/catalogue/:sectionName',
      name: 'Section Catalogue',
      component: catalogue,
      props: true
    },
    {
      path: '/section/catalogue/:sectionName/:catalogueid',
      name: 'Section Catalogue Details',
      component: catalogue,
      props: true
    },
    {
      path: '/section/:sectionName/search',
      name: 'Section Search',
      component: SectionSearch
    },
    {
      path: '/section/:sectionName/search/:category',
      name: 'Section Search Category',
      props : true,
      component: SectionSearch
    },
    {
      path: '/section/:sectionName/lists/',
      name: 'Section Asset Lists',
      component: AssetList,
      props: true
    },
    {
      path: '/section/:sectionName/lists/:assetListid',
      name: 'Section Asset List Details',
      component: AssetList,
      props: true
    },
    {
      path: '/asset/:assetDetailid',
      name: 'Asset Detail',
      component: AssetDetail,
      props: true
    },
    {
      path: '/addupdateassets/',
      name: 'Add / Update Assets',
      component: AddUpdateAssets
    },
    {
      path: '/section/addupdateassets/:sectionName',
      name: 'Add / Update Assets for Section',
      component: AddUpdateAssets
    },
    {
      path: '/callback',
      name: 'callback',
      component: SignInCallback
    },
    {
      path: '/silentRenewCallback',
      name: 'silentRenewCallback',
      component: SilentRenewCallback
    },
    {
      path: '/noAccess',
      name: 'noAccess',
      component: NoAccess
    },
    {
      path: '/attributemanagement',
      name: 'Attribute Manager',
      component: AttributeManagement
    },
    {
      path: '/cleanattributevalues',
      name: 'Clean Attribute Values',
      component: DataCleansing,
      beforeEnter: async (to, from, next) => {
        await store.dispatch('authentication/updateLoggedInStatus')
        if (store.getters['authentication/CanUserAccessCleanAttributeValues']) {
          next()
          return
        }

        next('/noAccess')
      }
    },
    {
      path: '/productsearchadmin',
      name: 'Product Search Admin',
      component: ProductSearchAdmin,
      beforeEnter: async (to, from, next) => {
        await store.dispatch('authentication/updateLoggedInStatus')
        if (store.getters['authentication/CanUserAccessProductSearchReindex']) {
          next()
          return
        }

        next('/noAccess')
      }
    }
  ]
})

/* LAZY LOAD EXAMPLE
{
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about")
  }
*/
